<template>
  <div>
    <h1 class="common__main-title">Timesheet List</h1>
    <div>
      <Search
        class="search"
        @search="search"
        ref="search"
      />
      <div class="d-flex mb-3">
        <b-button v-if="hasAuth(['admin'])"
          pill variant="primary" class="mr-2" @click="confirmWorkingResult">
          Monthly closing
        </b-button>
        <b-button
          pill
          variant="primary"
          :to="{name:'TimesheetBulkUpdate'}"
          class="mr-2"
        >
          Update
        </b-button>
      </div>
      <Pager v-model="pager" @changePage="changePage" class="mb-2" />
      <Timesheet :timesheets="timesheets" :pager="pager" ref="timeSheet" />
      <Pager v-model="pager" @changePage="changePage" />
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang='ts'>
import Vue, { VNode } from 'vue'
import _ from 'lodash';
import moment from 'moment';
import Pager from '@/components/parts/Pager.vue';
import Timesheet from '@/components/parts/timesheet/Timesheet.vue';
import Search from '@/components/parts/timesheet/TimesheetSearch.vue';
import Loading from '@/components/parts/modal/Loading.vue';
import { mapState } from 'vuex';
import { TimesheetConditions } from '@/store/timesheets/types'
import { Sort as SortType } from '@/store/sort.types'
import { Pager as PagerType } from '@/store/pager.types'
import { RootState } from '@/store/types';

export default Vue.extend({
  data: (): {
    isLoading: boolean,
    isFetchingTimesheets: boolean,
    conditions: TimesheetConditions,
  } => ({
    isLoading: false,
    isFetchingTimesheets: false,
    conditions: {
      yearMonth: moment().startOf('month'),
      positions: [],
      tutorNameOrId: '',
      confirmed: [true, false],
    },
  }),

  components: {
    Search,
    Pager,
    Timesheet,
    Loading,
  },

  mounted() {
    this.search(this.conditions, this.pager.current)
  },

  computed: {
    ...mapState({
      timesheets: (state: any): Timesheet[] => state.timesheets.timesheets,
      timesheetConditions: (state: any): TimesheetConditions => state.timesheets.conditions,
      pager: (state: any): PagerType => state.timesheets.pager,
      sort: (state: any): SortType => state.timesheets.sortBy,
    }),
  },

  methods: {
    /**
     * 許可を持っているか
     */
    hasAuth(acceptRoles: string[]): boolean {
      const auth = (this.$store.state as RootState).auth.profile?.authority
      return _.indexOf(acceptRoles, auth) !== -1
    },

    /**
     * pager処理
     */
    changePage(page: number) {
      if (this.isFetchingTimesheets) return
      this.search(this.timesheetConditions, page)
    },

    /**
     * 検索処理
     */
    search(conditions: TimesheetConditions, page: number = 1) {
      this.isFetchingTimesheets = true
      this.isLoading = true
      this.$store
        .dispatch('fetchTimesheets', {
          conditions,
          page,
          sortBy: this.sort,
        })
        .then(() => {
          this.isFetchingTimesheets = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    // 勤務集計
    async confirmWorkingResult() {
      const isOk = await this.$bvModal.msgBoxConfirm(
        'Do you want to aggregate work?',
      )
      if (isOk) {
        this.workingResult()
      }
    },

    workingResult() {
      this.isLoading = true
      this.$store
        .dispatch('workingResultsAggregate', {
          conditions: {
            tutorIds: (this.$refs.timeSheet as Timesheet).selectedTutorIds,
            yearMonth: (this.$refs.search as any).conditions.yearMonth,
          },
        })
        .then(() => {
          this.isLoading = false
          this.$bvModal.msgBoxOk('Success !')
        })
        .catch((error) => {
          this.isLoading = false
          let message: Error|string|string[] = error.response?.data?.message || error
          if (message instanceof Error) {
            message = message.message
          }
          if (_.isArray(message)) {
            const h = this.$createElement
            const messageNode: VNode[] = _.map(
              message,
              (stackError: {index: number, message: string}): VNode => {
                return h('p', `tutor ${stackError.index} has error: ${stackError.message}`)
              },
            ) as any;
            this.$bvModal.msgBoxOk(messageNode, { title: 'Error' })
          } else {
            this.$bvModal.msgBoxOk(`Error - ${message}`)
          }
        })
    },
  },
});
</script>
